<template>
	<svg
		:width="size"
		:height="size"
		viewBox="0 0 20 20"
		xmlns="http://www.w3.org/2000/svg"
		fill="none"
		role="img"
		:aria-hidden="ariaHidden"
	>
		<path
			d="M8.55667 17.5C8.70296 17.7533 8.91335 17.9637 9.16671 18.11C9.42006 18.2563 9.70746 18.3333 10 18.3333C10.2926 18.3333 10.5799 18.2563 10.8333 18.11C11.0867 17.9637 11.2971 17.7533 11.4433 17.5"
			:stroke="computedStroke"
			:stroke-width="strokeWidth"
			stroke-linecap="round"
			stroke-linejoin="round"
		/>
		<path
			d="M2.71833 12.7715C2.60947 12.8908 2.53763 13.0392 2.51155 13.1986C2.48547 13.358 2.50627 13.5215 2.57142 13.6693C2.63658 13.8171 2.74328 13.9428 2.87855 14.0311C3.01381 14.1193 3.17182 14.1664 3.33333 14.1665H16.6667C16.8282 14.1666 16.9862 14.1197 17.1216 14.0316C17.2569 13.9435 17.3637 13.818 17.4291 13.6703C17.4944 13.5226 17.5154 13.3591 17.4895 13.1997C17.4637 13.0402 17.392 12.8918 17.2833 12.7723C16.175 11.6298 15 10.4157 15 6.6665C15 5.34042 14.4732 4.06865 13.5355 3.13097C12.5979 2.19329 11.3261 1.6665 10 1.6665C8.67392 1.6665 7.40215 2.19329 6.46447 3.13097C5.52679 4.06865 5 5.34042 5 6.6665C5 10.4157 3.82417 11.6298 2.71833 12.7715Z"
			:stroke="computedStroke"
			:stroke-width="strokeWidth"
			stroke-linecap="round"
			stroke-linejoin="round"
		/>
	</svg>
</template>

<script>
export default {
	name: 'IconBell',
	props: {
		size: {
			type: [Number, String],
			default: 20
		},
		color: {
			type: String,
			default: 'currentColor'
		},
		filled: {
			type: Boolean,
			default: true
		},
		strokeWidth: {
			type: [Number, String],
			default: 1.65
		},
		ariaHidden: {
			type: Boolean,
			default: true
		}
	},
	computed: {
		computedFill() {
			return this.filled ? this.color : 'none'
		},
		computedStroke() {
			return this.color
		}
	}
}
</script>
